import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { verifyCertificate } from "../../redux/features/certificate/certificateService";
import { useDispatch, useSelector } from "react-redux";
import IBSLogo from "../../assets/images/brand/IBS landscape.png";
import CDCCertificateImage from "../../components/Certificate/CDCCertificate/CDCOther/CDCCertificateImage";
import IBSCOfficialCertificateImage from "../../components/Certificate/IBSCCertificate/IBSCOfficial/IBSCOfficialCertificateImage";
import IBSUOfficialCertificateImage from "../../components/Certificate/IBSUCertificate/IBSUOfficial/IBSUOfficialCertificateImage";
import IBSShadowCertificateImage from "../../components/Certificate/IBSShadowCertificateImage";
import SampleImg from "../../assets/images/brand/image.png";
import FAQ from "../../components/FAQ";
import { createLookup } from "../../redux/features/lookup/lookupService";

const VerificationPage = () => {
  const [searchParams] = useSearchParams();
  const document_ref = searchParams.get("ref");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isCertificateVerified, verifiedCertificate } =
    useSelector((state) => state.certificate.verifyCertificate);

  const [regNumber, setRegNumber] = useState(null);
  const [certificateImage, setCertificateImage] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const lastRef = useRef(null);
  const hasRef = !!document_ref;
  const isLoaded = !isVerifying && hasRef;
  const hasCertificate = isCertificateVerified && verifiedCertificate;

  useEffect(() => {
    if (!document_ref) return;

    // prevent duplicate calls
    if (lastRef.current === document_ref) return;

    lastRef.current = document_ref;
    setIsVerifying(true);
    setCertificateImage(null);

    dispatch(verifyCertificate({ document_ref }))
      .finally(() => {
        setIsVerifying(false);
        fetch("https://ipapi.co/json/")
          .then((res) => res.json())
          .then((data) => {
            const lookupData = {
              document_ref: document_ref,
              city: data?.city,
              country_code: data?.country_code,
              country_name: data?.country_name,
              region: data?.region,
              timezone: data?.timezone
            }
            dispatch(createLookup(lookupData))
          });
      });
  }, [document_ref]);

  useEffect(() => {
    if (verifiedCertificate) {
      setCertificateImage(null);
    }
  }, [verifiedCertificate]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (regNumber) {
      navigate(`?ref=${regNumber}`);
    }
  };

  useEffect(() => {
    if (document_ref && !regNumber) {
      setRegNumber(document_ref);
    }
  }, [document_ref]);

  return (
    <div className={styles.verificationSec}>
      <div className={styles.certSec}>
        {!hasRef && <IBSShadowCertificateImage />}
        {hasRef && isVerifying && <IBSShadowCertificateImage />}
        {isLoaded && (
          <>
            {/* Not found */}
            {!hasCertificate &&
              <>
                {/* <p>no certificate</p> */}
                <IBSShadowCertificateImage />
              </>}

            {/* Re-Issued */}
            {/* {hasCertificate &&
              verifiedCertificate.document_ref !==
                verifiedCertificate.certificate?.document_ref && (
                 <>
            <p>reissue</p><IBSShadowCertificateImage />
            </>
              )} */}

            {/*Cancelled */}
            {hasCertificate &&
              verifiedCertificate.certificate_status === "Cancelled" && (
                <>
                  {/* <p>cancelled</p> */}
                  <IBSShadowCertificateImage />
                </>
              )}
            {hasCertificate && !certificateImage && (
              <>
                {/* <p>no certificate image</p> */}
                <IBSShadowCertificateImage />
              </>
            )}
            {/*Valid */}
            {hasCertificate &&
              verifiedCertificate.certificate_status !== "Cancelled" &&
              verifiedCertificate.document_ref ===
              verifiedCertificate.certificate?.document_ref &&
              (verifiedCertificate?.certificate?.certificate_template?.name ===
                "IBSU Offical Certificate" &&
                verifiedCertificate?.certificate?.certificate_template
                  ?.certificate_type?.name === "OFFICIAL" ? (
                <IBSUOfficialCertificateImage
                  data={verifiedCertificate?.certificate}
                  onImageGenerated={setCertificateImage}
                />
              ) : verifiedCertificate?.certificate?.certificate_template
                ?.name === "IBSC Official Certificate" &&
                verifiedCertificate?.certificate?.certificate_template
                  ?.certificate_type?.name === "OFFICIAL" ? (
                <IBSCOfficialCertificateImage
                  data={verifiedCertificate?.certificate}
                  onImageGenerated={setCertificateImage}
                />
              ) : (
                <CDCCertificateImage
                  data={verifiedCertificate?.certificate}
                  onImageGenerated={setCertificateImage}
                />
              ))}
          </>
        )}
        {certificateImage &&
          verifiedCertificate?.document_ref ===
          verifiedCertificate?.certificate?.document_ref &&
          certificateImage &&
          verifiedCertificate?.certificate_status !== "Cancelled" && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <img
                src={certificateImage}
                alt="Certificate Preview"
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  border: "1px solid #ccc",
                }}
              />
            </div>
          )}
      </div>
      <div className={styles.container}>
        {/* No ref entered */}
        {!hasRef && (
          <div className={styles.searchCardOne}>
            <div className={styles.notRefCard}>
              <p className={styles.notRefTitle}>Verify an IBS Certificate</p>
              <p className={styles.notRefPara}>
                Enter the <span className={styles.boldText}>Certificate Number / Document Reference ID </span> printed on the
                certificate to verify its authenticity.
              </p>
              <div className={styles.studentSearchSection}>
                <input
                  id="regNumber"
                  placeholder="Document Reference Id"
                  type="text"
                  value={regNumber || ""}
                  name="regNumber"
                  onChange={(e) => setRegNumber(e.target.value)}
                  className={styles.searchInput}
                />
                <button
                  type="button"
                  className={styles.searchBtn}
                  onClick={handleSearch}
                >
                  <FontAwesomeIcon
                    icon={faSearch}
                    aria-hidden="true"
                    color="white"
                    className={styles.searchIcon}
                  />
                  Search
                </button>
              </div>
              <div className={styles.notRefBody}>
                <div className={styles.notRefBodyLeft}>
                  <p className={styles.notRefTitle}>How to Verify a Certificate</p>
                  <ol>
                    <li>Locate the <span className={styles.boldText}>Certificate Number / Document Reference </span> printed on the certificate (near the QR code).</li>
                    <li>Enter the number in the search box above.</li>
                    <li>Click <span className={styles.boldText}>Search</span> to view the verification result.</li>
                  </ol>
                  <p className={styles.notRefItalic}>Example: NFFE250003, DAF24001, IBSCODA24004</p>
                </div>
                <div className={styles.notRefBodyRight}>
                  <img src={SampleImg} className={styles.sampleImg} alt="Sample QR" />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Loading */}
        {hasRef && isVerifying && (
          <div className={styles.searchCard}>
            <div className={styles.studentSearchSection}>
              <input
                id="regNumber"
                placeholder="Document Reference Id"
                type="text"
                value={regNumber || ""}
                name="regNumber"
                onChange={(e) => setRegNumber(e.target.value)}
                className={styles.searchInput}
              />
              <button
                type="button"
                className={styles.searchBtn}
                onClick={handleSearch}
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  aria-hidden="true"
                  color="white"
                  className={styles.searchIcon}
                />
                Search
              </button>
            </div>
            <div className={styles.verificationCard}>
              <FontAwesomeIcon icon={faMedal} size="5x" color="#e3e0e0" />
              <h1 className={styles.certificateTitleDisabled}>
                Certificate Status
              </h1>
              <p className={styles.certificateTextDisabled}>
                Enter the document reference ID to get certificate.
              </p>
              <div className={styles.row}>
                <div className={styles.dateTextDisabled}>
                  Issue date:{" "}
                  xxxxxxxxxxxx
                </div>
                <div className={styles.dateTextDisabled}>
                  Completion date:{" "}
                  xxxxxxxxxxxxxxx
                </div>
              </div>
              <img
                src={IBSLogo}
                alt="Logo"
                className={styles.verifyLogoImgDisabled}
              />
            </div>
          </div>
        )}

        {/* 3️⃣ API responded */}
        {isLoaded && (
          <>
            {/* Not found */}
            {!hasCertificate && (
              <div className={styles.searchCard}>
                <div className={styles.studentSearchSection}>
                  <input
                    id="regNumber"
                    placeholder="Document Reference Id"
                    type="text"
                    value={regNumber || ""}
                    name="regNumber"
                    onChange={(e) => setRegNumber(e.target.value)}
                    className={styles.searchInput}
                  />
                  <button
                    type="button"
                    className={styles.searchBtn}
                    onClick={handleSearch}
                  >
                    <FontAwesomeIcon
                      icon={faSearch}
                      aria-hidden="true"
                      color="white"
                      className={styles.searchIcon}
                    />
                    Search
                  </button>
                </div>
                <div className={styles.verificationCard}>
                  <FontAwesomeIcon icon={faMedal} size="4x" color="red" />
                  <h1 className={styles.certificateTitle}>
                    Certificate Not Found
                  </h1>
                  <p className={styles.certificateTex}>
                    There is no certificate for this document reference ID.
                  </p>
                </div>
              </div>
            )}
            {/* Re-Issued */}
            {hasCertificate &&
              verifiedCertificate.document_ref !==
              verifiedCertificate.certificate?.document_ref && (
                <div className={styles.searchCard}>
                  <div className={styles.studentSearchSection}>
                    <input
                      id="regNumber"
                      placeholder="Document Reference Id"
                      type="text"
                      value={regNumber || ""}
                      name="regNumber"
                      onChange={(e) => setRegNumber(e.target.value)}
                      className={styles.searchInput}
                    />
                    <button
                      type="button"
                      className={styles.searchBtn}
                      onClick={handleSearch}
                    >
                      <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden="true"
                        color="white"
                        className={styles.searchIcon}
                      />
                      Search
                    </button>
                  </div>
                  <div className={styles.verificationCard}>
                    <FontAwesomeIcon icon={faMedal} size="4x" color="green" />
                    <h1 className={styles.certificateTitle}>
                      This certificate is Re-Issued
                    </h1>
                    <p className={styles.detailsPara}>
                      <span className={styles.highlightText}>
                        {verifiedCertificate.document_ref}
                      </span>{" "}
                      has been replaced by{" "}
                      <span className={styles.highlightText}>
                        {verifiedCertificate.certificate?.document_ref}
                      </span>
                    </p>
                    <img
                      src={IBSLogo}
                      alt="Logo"
                      className={styles.verifyLogoImg}
                    />
                  </div>
                </div>
              )}

            {/* Cancelled */}
            {hasCertificate &&
              verifiedCertificate.certificate_status === "Cancelled" && (
                <div className={styles.searchCard}>
                  <div className={styles.studentSearchSection}>
                    <input
                      id="regNumber"
                      placeholder="Document Reference Id"
                      type="text"
                      value={regNumber || ""}
                      name="regNumber"
                      onChange={(e) => setRegNumber(e.target.value)}
                      className={styles.searchInput}
                    />
                    <button
                      type="button"
                      className={styles.searchBtn}
                      onClick={handleSearch}
                    >
                      <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden="true"
                        color="white"
                        className={styles.searchIcon}
                      />
                      Search
                    </button>
                  </div>
                  <div className={styles.verificationCard}>
                    <FontAwesomeIcon icon={faMedal} size="4x" color="red" />
                    <h1 className={styles.certificateTitle}>
                      This Certificate is Cancelled
                    </h1>
                    <p className={styles.detailsPara}>
                      Reason: {verifiedCertificate.reason}
                    </p>
                    <img
                      src={IBSLogo}
                      alt="Logo"
                      className={styles.verifyLogoImg}
                    />
                  </div>
                </div>
              )}

            {/* Valid */}
            {hasCertificate &&
              verifiedCertificate.certificate_status !== "Cancelled" &&
              verifiedCertificate.document_ref ===
              verifiedCertificate.certificate?.document_ref && (
                <div className={styles.searchCard}>
                  <div className={styles.studentSearchSection}>
                    <input
                      id="regNumber"
                      placeholder="Document Reference Id"
                      type="text"
                      value={regNumber || ""}
                      name="regNumber"
                      onChange={(e) => setRegNumber(e.target.value)}
                      className={styles.searchInput}
                    />
                    <button
                      type="button"
                      className={styles.searchBtn}
                      onClick={handleSearch}
                    >
                      <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden="true"
                        color="white"
                        className={styles.searchIcon}
                      />
                      Search
                    </button>
                  </div>
                  <div className={styles.verificationCard}>
                    <FontAwesomeIcon icon={faMedal} size="4x" color="green" />
                    <h1 className={styles.certificateTitle}>
                      This is a Valid Certificate
                    </h1>
                    <p className={styles.detailsPara}>
                      <span className={styles.highlightText}>
                        {verifiedCertificate.certificate?.student_name}
                      </span>{" "}
                      completed{" "}
                      <span className={styles.highlightText}>
                        {
                          verifiedCertificate.certificate?.course_batch ?
                            verifiedCertificate.certificate?.course_batch?.course
                              ?.name : verifiedCertificate.certificate?.other_course
                        }
                      </span>
                    </p>
                    <div className={styles.row}>
                      <div className={styles.dateText}>
                        Issue date:{" "}
                        {verifiedCertificate.certificate?.issued_date}
                      </div>
                      <div className={styles.dateText}>
                        Completion date:{" "}
                        {verifiedCertificate.certificate?.completion_date}
                      </div>
                    </div>
                    <img
                      src={IBSLogo}
                      alt="Logo"
                      className={styles.verifyLogoImg}
                    />
                  </div>
                </div>
              )}
          </>
        )}
      </div>
    </div>
  );
};

export default VerificationPage;
